import ReactLoading from "react-loading";
import JugadoresCard from "./JugadoresCard";

function JugadoresList({
    isLoading,
    isError,
    hasData,
    jugadores,
    filteredTotal,
    totalJugadores,
    currentPage,
    totalPages,
    pageNumbers,
    onPageChange,
}) {
    const visiblePageNumbers = (() => {
        const MAX_VISIBLE_PAGES = 5;

        if (pageNumbers.length <= MAX_VISIBLE_PAGES) {
            return pageNumbers;
        }

        const halfWindow = Math.floor(MAX_VISIBLE_PAGES / 2);
        let startIndex = Math.max(0, currentPage - 1 - halfWindow);
        let endIndex = startIndex + MAX_VISIBLE_PAGES;

        if (endIndex > pageNumbers.length) {
            endIndex = pageNumbers.length;
            startIndex = endIndex - MAX_VISIBLE_PAGES;
        }

        return pageNumbers.slice(startIndex, endIndex);
    })();

    if (isLoading) {
        return (
            <section className="rounded-xl border border-white/10 bg-[#102216] p-10 text-center">
                <ReactLoading type="bars" color="#22c55e" width={80} className="m-auto mb-6" />
                <p className="text-slate-200 text-lg font-semibold">Buscando jugadores...</p>
            </section>
        );
    }

    if (isError) {
        return (
            <section className="rounded-xl border border-red-400/30 bg-red-950/20 p-8 text-center text-red-200 font-medium">
                No se pudieron cargar los jugadores en este momento.
            </section>
        );
    }

    if (!hasData || filteredTotal === 0) {
        return (
            <section className="rounded-xl border border-white/10 bg-[#102216] p-8 text-center text-slate-200 font-medium">
                No hay jugadores para mostrar con esa búsqueda.
            </section>
        );
    }

    return (
        <section>
            <div className="grid grid-cols-1 cellphone:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6 mb-8">
                {jugadores.map((jugador) => (
                    <JugadoresCard key={jugador.nombre} jugador={jugador} />
                ))}
            </div>

            <div className="pt-6 border-t border-white/10 space-y-3">
                <p className="text-center text-xs sm:text-sm text-slate-400 font-medium">
                    Mostrando <span className="text-white font-bold">{jugadores.length}</span> de <span className="text-white font-bold">{filteredTotal}</span> jugadores
                    {filteredTotal !== totalJugadores ? ` (total: ${totalJugadores})` : ""}
                </p>

                <div className="overflow-x-auto">
                    <div className="flex items-center justify-center gap-1.5 min-w-max px-1">
                        <button
                            type="button"
                            onClick={() => onPageChange(Math.max(1, currentPage - 1))}
                            disabled={currentPage <= 1}
                            className="h-10 sm:h-9 px-3 rounded-lg bg-[#102216] border border-white/10 text-slate-300 disabled:opacity-40 disabled:cursor-not-allowed hover:border-green-500 active:border-green-500 transition-colors"
                        >
                            ←
                        </button>

                        {visiblePageNumbers.map((pageNumber) => (
                            <button
                                type="button"
                                key={pageNumber}
                                onClick={() => onPageChange(pageNumber)}
                                className={`h-10 sm:h-9 min-w-10 sm:min-w-9 px-3 rounded-lg text-sm font-bold border transition-colors ${pageNumber === currentPage
                                    ? "bg-green-500 text-[#062a1a] border-green-500"
                                    : "bg-[#102216] text-slate-200 border-white/10 hover:border-green-500 active:border-green-500"
                                    }`}
                            >
                                {pageNumber}
                            </button>
                        ))}

                        <button
                            type="button"
                            onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
                            disabled={currentPage >= totalPages}
                            className="h-10 sm:h-9 px-3 rounded-lg bg-[#102216] border border-white/10 text-slate-300 disabled:opacity-40 disabled:cursor-not-allowed hover:border-green-500 active:border-green-500 transition-colors"
                        >
                            →
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default JugadoresList;
